import './admin.scss';
import React, { useState, useEffect } from 'react';
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import {  Panel, PanelBody, TabPanel,PanelRow, Button, Spinner ,Modal} from '@wordpress/components';
import GeneralTab from './admin/GeneralTab';
import TranslationTab from './admin/TranslationTab';
import MorePluginTab from './admin/MorePluginTab';

const AdminApp = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false); // State for popup visibility
    const [popupMessage, setPopupMessage] = useState(''); // State for popup message

    const openPopup = (message) => {
        setPopupMessage(message);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupMessage('');
    };
   const tabs = [
        
        {
            name: 'GeneralTab',
            title: 'General Setting',
            content: <GeneralTab openPopup={openPopup}/>,
        },
        {
            name: 'TranslationTab',
            title: 'Translation',
            content: <TranslationTab  openPopup={openPopup}/>,
        },
        {
            name: 'MorePluginTab',
            title: 'More Free Plugins',
            content: <MorePluginTab  openPopup={openPopup}/>,
        }
        
    ];

    return (
        <>
        <Panel>
            <TabPanel
                className=""
                activeClass="active-tab"
                tabs={tabs}
            >
                {(tab, selected) => (
                    <div
                        className={`tab-content ${
                            tab.name === selected ? 'active-tab' : ''
                        }`}
                    >
                        {tab.content}
                    </div>
                )}
            </TabPanel>
        </Panel>
        {isPopupOpen && (
                <Modal title={popupMessage} onRequestClose={closePopup}>
                </Modal>
            )}
        </>
    );
};


domReady(() => {
    const root = createRoot(
        document.getElementById('GMWPDL-admin-root')
    );
    root.render(<AdminApp />);
});